export default {
  id: 17,
  title: 'Target #17 - Fidget Spinner',
  url: 'https://cssbattle.dev/play/17',
  colors: ['#09042A', '#E78481', '#F5BB9C'],
  solution:
    '<p><a a><a b><a c><a d><style>body{background:#09042a}a,p{position:fixed}a{width:60;height:60;border-radius:50%;border:10px solid}p{top:110;left:170;width:60;height:50;background:#e78481}a[a],a[b]{top:110;border-color:#e78481}a[a]{left:100}a[b]{right:100}a[c],a[d]{left:160;border-color:#09042a;background:#f5bb9c}a[c]{top:57}a[d]{bottom:57}</style>',
}
